module.exports = "/global_cta-3c97d9afb3dac1b9d60f70122b29b86a.svg";